import * as Yup from "yup";
import { ErrorMessages } from "ErrorMessages";

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .nullable()
    .required(ErrorMessages.requiredField),
  lastName: Yup.string()
    .nullable()
    .required(ErrorMessages.requiredField),
  signature: Yup.object()
    .nullable()
    .required(ErrorMessages.requiredField),
});
